import type {
    CreateThumbnailRequestBody,
    CreateThumbnailResponseBody,
    CreateUploadResponseBody,
} from '@common/interfaces/api/uploadsApi';
import type { IUploadAdd } from '@common/validation/upload';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/uploads';

export async function createThumbnail(
    body: CreateThumbnailRequestBody,
    signal: AbortSignal
): Promise<CreateThumbnailResponseBody> {
    const url = `${baseUrl}/thumbnail`;
    const response = await fetchJson({ body, method: 'POST', signal, url });

    return response.json;
}

export async function createUpload(body: IUploadAdd, signal: AbortSignal): Promise<CreateUploadResponseBody> {
    const response = await fetchJson({ body, method: 'POST', signal, url: baseUrl });

    return response.json;
}

export async function deleteUpload(uploadId: string, signal: AbortSignal): Promise<void> {
    const url = `${baseUrl}/${uploadId}`;

    await fetchJson({ method: 'DELETE', signal, url });
}
